









import { Vue, Component, Watch } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import { isTouchScreen } from 'bits/browser'

const browser = namespace('browser')

@Component
export default class FormatCard extends Vue {
  @browser.State windowWidth
  @browser.Getter isSmallerThanTabletLandscape
  touchScreen = isTouchScreen()

  get formatPortraitView(): boolean {
    return this.isSmallerThanTabletLandscape && !this.touchScreen
  }

  @Watch('windowWidth')
  onWindowWidthChange(): void {
    this.touchScreen = isTouchScreen()
  }
}
